/*
 *     Copybottom (c) 2020 Bcame S.r.l.. All bottoms reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <transition leave-active-class="animate__animated animate__fadeOut">
    <div class="wrapp-bottombar" v-show="showBottomBar">
      <transition
      enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut"
      @after-leave="showBottomBar = false">
        <div v-show="startAnimation" class="bottombar-overlay" @click="closeBottomBar"></div>
      </transition>
      <transition
      enter-active-class="animate__animated animate__fadeIn animate__slideInUp animate__faster"
      leave-active-class="animate__animated animate__fadeOut animate__slideOutDown animate__faster"
      @before-enter="startAnimation = showBottomBar = true"
      @after-enter="toggleContent(true)"
      @before-leave="toggleContent(false)"
      @after-leave="startAnimation = false">
        <div class="wrapp-bottombar__content" v-show="bottomActiveComponent.component" :class="dynamicClass" ref="bottomBar">
          <div class="wrapp-bottombar__content__header">
            <button class="btn btn-icon btn-rounded btn-icon-medium btn-icon-border-black close-bottombar" @click="closeBottomBar">
              <svg class="o-icon stroke-black"><use xlink:href="#close"></use></svg>
            </button>
          </div>
          <div class="wrapp-bottombar__content__body">
            <transition
            enter-active-class="animate__animated animate__fadeIn animate__delay_0.4s"
            leave-active-class="animate__animated animate__fadeOut">
              <div class="wrapp-bottombar__content__body__dynamic" v-show="showContent" :key="bottomActiveComponent.id">
                <component :is="bottomActiveComponent.component" v-bind="bottomActiveComponent.props"></component>
              </div>
            </transition>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import { EventBus } from '@/helpers'

export default {
  name: 'BottomNavigation',
  props: {
    showGoBack: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      showContent: false,
      showBottomBar: false,
      startAnimation: false
    }
  },
  computed: {
    bottomNavHistory () {
      return this.$store.state.ui.bottomNavHistory
    },
    bottomActiveComponent () {
      return this.$store.getters['ui/getBottomActiveComponent']
    },
    dynamicClass () {
      let classObj = {}
      let bottomActiveComponent = this.$store.state.ui.bottomActiveComponent
      if (bottomActiveComponent && bottomActiveComponent.component && bottomActiveComponent.component.name) {
        classObj = {
          [`component-active-${bottomActiveComponent.component.name.toLowerCase()}`]: true
        }
      }
      return classObj
    }
  },
  methods: {
    closeBottomBar () {
      this.animation = false
      this.$store.commit('ui/setBottomActiveComponent', {})
    },
    goBackHistory () {
      this.$store.dispatch('ui/loadBottomActiveComponent', { isBack: true })
    },
    toggleContent (toggle) {
      this.showContent = toggle
      this.startAnimation = toggle
    }
  },
  mounted () {
    EventBus.$on('BottomNavigation:closeNav', this.closeBottomBar)
  },
  destroyed () {
    EventBus.$off('BottomNavigation:closeNav', this.closeBottomBar)
  }
}
</script>
